module.exports = __webpack_public_path__ + "img/quote-start.b175e34f.svg";